import { userApiUrl } from '@/entities/apis/url';
import axios from '@/libs/api/axios';
import { PostConsultationRequest } from '@/types/api';

export const postConsultation = async (data: PostConsultationRequest) => {
  const response = await axios.post(userApiUrl.consultation, data);
  return response.data;
};
